import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../../components/AppIcon";

const formatCurrency = (amount) =>
  new Intl.NumberFormat("ro-RO", {
    style: "currency",
    currency: "RON",
  }).format(Number(amount || 0));

const RevenueByStaffList = ({
  title,
  rows = [],
  total = 0,
  loading = false,
}) => {
  const { t } = useTranslation();
  const safeRows = Array.isArray(rows) ? rows : [];
  const totalSafe = Number(total || 0);
  const displayTitle = title ?? t("admin.revenueByStaff");

  return (
    <div className="bg-background border border-border rounded-lg p-6">
      <div className="flex items-start justify-between gap-4 mb-4">
        <div>
          <h3 className="text-lg font-semibold text-foreground">{displayTitle}</h3>
          <p className="text-xs text-text-secondary mt-1">
            {t("admin.total")}{" "}
            <span className="font-medium text-foreground">
              {loading ? "…" : formatCurrency(totalSafe)}
            </span>
          </p>
        </div>
        <div className="flex items-center gap-2 text-xs text-text-secondary">
          <Icon name="User" size={16} />
          <span>{loading ? "…" : t("admin.staffCount", { count: safeRows.length })}</span>
        </div>
      </div>

      <div className="space-y-3 max-h-96 overflow-auto pr-1">
        {loading ? (
          <div className="text-sm text-text-secondary">{t("admin.loading")}</div>
        ) : safeRows.length ? (
          safeRows.map((r) => {
            const value = Number(r?.value || 0);
            const percent = totalSafe > 0 ? (value / totalSafe) * 100 : 0;

            return (
              <div key={r?.staffKey || r?.name} className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-lg bg-muted flex items-center justify-center shrink-0">
                  <Icon name="User" size={18} />
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-3">
                    <div className="truncate text-sm font-medium text-foreground">
                      {r?.name || t("admin.noName")}
                    </div>
                    <div className="text-sm font-semibold text-foreground tabular-nums">
                      {formatCurrency(value)}
                    </div>
                  </div>

                  <div className="mt-2 h-2 bg-muted rounded-full overflow-hidden">
                    <div
                      className="h-full bg-primary"
                      style={{ width: `${Math.min(100, Math.max(0, percent))}%` }}
                    />
                  </div>

                  <div className="mt-1 text-xs text-text-secondary">
                    {percent.toFixed(1)}{t("admin.percentOfTotal")}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="text-sm text-text-secondary">
            {t("admin.noRevenue")}
          </div>
        )}
      </div>
    </div>
  );
};

export default RevenueByStaffList;
